module.exports = __webpack_public_path__ + "static/media/room-6.7cf22a3b.jpeg";